import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn,Router } from '@angular/router';
import { AuthService } from '../services/auths';

@Injectable({ providedIn: 'root' })
class PermissionsService {
   constructor(private readonly authService: AuthService,private router: Router) { }

   canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      const currentAuth = this.authService.currentAuthValue;
      if (currentAuth) {
         // logged in so return true
         return true;
      }

      // not logged in so redirect to login page with the return url
      this.router.navigate(['/auth/login'], {
         queryParams: { returnUrl: state.url }
      });
      return false;
   }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
   return inject(PermissionsService).canActivate(next, state);
}
